import Button from "../Button";
import "./_projectItem.scss";

function ProjectItem({ project, classn = null }) {

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  let cn = classn? `project-item ${classn}` : 'project-item';

  return (
    <div className={cn}>
      <div className="item-info">
        <div className="item-content">
          <h3>{project.name}</h3>
          <p>{project.description}</p>
          <div className="technologies">
            {project.technologies.map((tec) => tec)}
          </div>
        </div>
        <div className="item-links">
            <Button click={()=>openInNewTab(project.urllive)}>
            Live
            </Button>
            <Button click={()=>openInNewTab(project.urlrepo)}>
            Code
            </Button>
        </div>
      </div>

      <img src={project.img} alt={project.name} />
    </div>
  );
}

export default ProjectItem;
